import "../i18n";
import AppProviders from "./AppProviders";
import AppThemedContent from "./AppThemedContent";
import AppRouter from "./AppRouter";

function App() {
  return (
    <AppProviders>
      <AppThemedContent>
        <AppRouter />
      </AppThemedContent>
    </AppProviders>
  );
}

export default App;
